import { GET_SHIPPING_COST, SHIPPING_COST_ERROR, PAYMENT_ERROR } from "./types";
import { firebase } from "../../firebase";
import axios from "axios";

export const getCosts = () => async (dispatch) => {
  try {
    const db = firebase.firestore();
    const snapshots = await db
      .collection("configuration")
      .doc("configuration")
      .get();
    dispatch({ type: GET_SHIPPING_COST, payload: snapshots.data() });
  } catch (error) {
    dispatch({ type: GET_SHIPPING_COST, payload: SHIPPING_COST_ERROR });
  }
};

export const makePayment = (body) => async (dispatch) => {
  try {
    await axios
      .post(`${process.env.REACT_APP_apiUrl}/paymentTransaction`, body)
      .then((response) => {});
  } catch (error) {
    dispatch({
      type: PAYMENT_ERROR,
      payload: error.message,
    });
  }
};
